export default "__VITE_ASSET__DdpVBMe7__"